import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as text from '../../../../text'
import * as models from '../../../models'
import { Store } from '../../../store'

import * as duration from './duration-input'

/** Form controls for manually editing the active date range selection. */
@ngCore.Component({
  imports: [text.Component, duration.Component],
  selector: 'atn-ds-date-range-overlay-content-form',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** Exposes the start date of the currently selected date range */
  public readonly dateStartSg = ngCore.computed(
    (dateRange = this.store.editingDateRangeSg()) => dateRange.start,
  )

  /** Exposes the end date of the currently selected date range */
  public readonly dateEndSg = ngCore.computed(
    (dateRange = this.store.editingDateRangeSg()) => dateRange.end,
  )

  /** Formats the currently selected start date for the text input. */
  public readonly formattedDateStartSg = ngCore.computed(
    (date = this.dateStartSg()) => ents.core.display.date.format(date),
  )

  /** Formats the currently selected end date for the text input. */
  public readonly formattedDateEndSg = ngCore.computed(
    (date = this.dateEndSg()) => ents.core.display.date.format(date),
  )

  /**
   * Handles start date change from custom input.
   */
  public startDateChangeHandler(value?: string): void {
    const newStart = value ? models.DateRange.Edge.parseFrom(value) : null
    const current = this.store.editingDateRangeSg()
    const isStartAfterEnd =
      !!newStart && !!current.end && newStart.getTime() > current.end.getTime()

    const newRange = isStartAfterEnd
      ? // New start is after current end → clear end
        models.DateRange.generate({ start: newStart })
      : models.DateRange.generate({ end: current.end, start: newStart })

    this.store.patchState({ editingDateRange: newRange, lastChanged: 'start' })
  }

  /**
   * Handles end date change from custom input.
   */
  public endDateChangeHandler(value?: string): void {
    const newEnd = value ? models.DateRange.Edge.parseFrom(value) : null
    const current = this.store.editingDateRangeSg()

    const isEndBeforeStart =
      !!newEnd && !!current.start && newEnd.getTime() < current.start.getTime()

    const newRange = isEndBeforeStart
      ? // New end is before start → clear start
        models.DateRange.generate({ end: newEnd })
      : models.DateRange.generate({ end: newEnd, start: current.start })

    this.store.patchState({
      editingDateRange: newRange,
      lastChanged: 'end',
    })
  }
}
